const AD = {
  ibanLength: 24,
};
export { AD };
